var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrugada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg38",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .brugada {\n        stroke: #000;\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brugada__x28_ionchanneldisease_x29_",
    transform: "translate(-55,-84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "brugada",
    d: "m 65.08,88.37 c -0.06,0 0.11,0 0.04,-0.01 0.67,0.83 1.74,1.37 2.97,1.37 1.23,0 2.33,-0.55 3,-1.39",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "brugada",
    d: "M 65.69,88.34",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "brugada",
    d: "m 71.09,106.06 c -0.66,-0.86 -1.75,-1.43 -3,-1.43 -1.25,0 -2.3,0.55 -2.97,1.38",
    id: "path36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "brugada",
    x: 59.490002,
    y: 88.330002,
    width: 5.5700002,
    height: 17.75,
    id: "rect37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "brugada",
    x: 71.089996,
    y: 88.330002,
    width: 5.5700002,
    height: 17.75,
    id: "rect38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrugada);
export default __webpack_public_path__ + "static/media/Brugada.7e2260a5c207438a8de0597d8c21704d.svg";
export { ForwardRef as ReactComponent };